import React, { useState, useMemo, useRef, useEffect } from "react";
import { MenuSelect, MenuSelect2 } from "./Form";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { FiEdit, FiEye } from "react-icons/fi";
import {
  RiDeleteBin6Line,
  RiDeleteBinLine,
  RiEdit2Line,
  RiFileDownloadLine,
} from "react-icons/ri";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { getAge } from "../utils/age";
import { MdMedicalServices } from "react-icons/md";
import { FaFileDownload, FaTimes } from "react-icons/fa";
import Ecocardiograma from "../screens/Studies/Ecocardiograma";
import Modal from "./Modals/Modal";
import AnalisisGabinete from "../screens/Studies/AnalisisGabinete";
import { useDispatch } from "react-redux";
import { setPatient } from "../redux/features/patientSlice";
import Loading from "../screens/Loading";
import Laboratorio from "../screens/Studies/Laboratorio";
import { FileIcon } from "./FileIcon";
import { useViewType } from "../utils/ViewState";
import { formatDateWithoutTimeZoneIssues } from "../utils/dateWithoutTimeZone";

const thclass = "text-start text-sm font-medium py-3 px-2 whitespace-nowrap";
const tdclass = "text-start text-sm py-4 px-2 whitespace-nowrap";

export function Transactiontable({
  data,
  action,
  functions,
  status,
  uniquePatient,
}) {
  // Referencia para el contenedor de la tabla
  const tableContainerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // Actualizar el ancho del contenedor cuando cambie el tamaño de la ventana
  useEffect(() => {
    const updateWidth = () => {
      if (tableContainerRef.current) {
        setContainerWidth(tableContainerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);

  const DropDown1 = [
    {
      title: "Baja",
      icon: RiDeleteBin6Line,
      onClick: functions.delete,
    },
    {
      title: "Imprimir",
      icon: RiFileDownloadLine,
      onClick: functions.print,
    },
  ];

  // Definición de anchos de columna como antes
  const columnWidths = uniquePatient
    ? {
        hash: "w-[5%]",
        date: "w-[12%]",
        motivo: "w-[18%]",
        monto: "w-[12%]",
        saldo: "w-[12%]",
        metodo: "w-[12%]",
        observaciones: "w-[20%]",
        actions: "w-[9%]",
      }
    : {
        hash: "w-[5%]",
        patient: "w-[18%]",
        date: "w-[10%]",
        motivo: "w-[12%]",
        monto: "w-[10%]",
        saldo: "w-[10%]",
        metodo: "w-[10%]",
        observaciones: "w-[20%]",
        actions: "w-[5%]",
      };

  // Función auxiliar para truncar texto
  const truncateText = (text, maxLength) => {
    if (typeof text !== "string") return "";
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + "...";
  };

  return (
    <>
      {status === "loading" ? (
        <Loading />
      ) : data?.length > 0 ? (
        // Contenedor responsivo con scroll horizontal
        <div className="relative w-full " ref={tableContainerRef}>
          <table className="table-auto w-full min-w-[700px] mb-10">
            {" "}
            {/* min-w para asegurar que no se achique demasiado */}
            <thead className="bg-dry rounded-md overflow-hidden">
              <tr>
                <th className={`${thclass} ${columnWidths.hash}`}>#</th>
                {!uniquePatient && (
                  <th className={`${thclass} ${columnWidths.patient}`}>
                    Paciente
                  </th>
                )}
                <th className={`${thclass} ${columnWidths.date}`}>Fecha</th>
                <th className={`${thclass} ${columnWidths.motivo}`}>Motivo</th>
                <th className={`${thclass} ${columnWidths.monto}`}>
                  Monto<span className="text-xs font-light">(bs)</span>
                </th>
                <th className={`${thclass} ${columnWidths.saldo}`}>Saldo</th>
                <th className={`${thclass} ${columnWidths.metodo}`}>Método</th>
                <th className={`${thclass} ${columnWidths.observaciones}`}>
                  Observaciones
                </th>
                {action && (
                  <th className={`${thclass} ${columnWidths.actions}`}>
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr
                  key={item.id}
                  className="border-b border-border hover:bg-greyed transitions"
                >
                  <td className={`${tdclass} ${columnWidths.hash}`}>
                    {index + 1}
                  </td>

                  {!uniquePatient && (
                    <td className={`${tdclass} ${columnWidths.patient}`}>
                      <div className="flex gap-4 items-center">
                        <div>
                          <h4 className="text-sm font-medium">
                            {`${item?.patient?.persona?.nombre || ""} ${
                              item.patient?.persona?.apellidos || ""
                            }`}{" "}
                          </h4>
                        </div>
                      </div>
                    </td>
                  )}
                  <td className={`${tdclass} ${columnWidths.date}`}>
                    {new Date(item.created_at).toLocaleDateString("en-GB")}
                  </td>
                  <td className={`${tdclass} ${columnWidths.motivo}`}>
                    {/* Aplica las clases de truncamiento al span */}
                    <span
                      className={`py-1 px-4 ${
                        item.status === "Paid"
                          ? "bg-subMain text-subMain"
                          : item.status === "Pending"
                          ? "bg-orange-500 text-orange-500"
                          : item.status === "Cancel" &&
                            "bg-red-600 text-red-600"
                      } bg-opacity-10 text-xs rounded-xl inline-block w-full overflow-hidden text-ellipsis`}
                    >
                      {truncateText(item.motivo, 30)}
                    </span>
                  </td>
                  <td
                    className={`${tdclass} font-semibold ${columnWidths.monto}`}
                  >
                    {item.monto}
                  </td>
                  <td className={`${tdclass} ${columnWidths.saldo}`}>
                    {item.saldo}
                  </td>
                  <td className={`${tdclass} ${columnWidths.metodo}`}>
                    {item.metodo}
                  </td>
                  <td className={`${tdclass} ${columnWidths.observaciones}`}>
                    {/* Aplica las clases de truncamiento directamente al td */}
                    <span className="inline-block w-full overflow-hidden text-ellipsis">
                      {truncateText(item.observaciones, 30)}
                    </span>
                  </td>
                  {action && (
                    <td
                      className={`${tdclass} ${columnWidths.actions} relative`}
                    >
                      {/* Esta celda no tiene las clases de truncamiento */}
                      <MenuSelect
                        datas={DropDown1}
                        item={item}
                        containerWidth={containerWidth}
                      >
                        <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg flex justify-center mx-auto">
                          <BiDotsHorizontalRounded />
                        </div>
                      </MenuSelect>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <h2>Todavia no hay registros</h2>
      )}
    </>
  );
}

export function NotificationTable({ action, functions, notifications }) {
  const DropDown1 = [
    {
      title: "Editar",
      icon: FiEdit,
      onClick: (item) => {
        functions.edit(item);
      },
    },
    {
      title: "Baja",
      icon: RiDeleteBin6Line,
      onClick: (item) => {
        functions.baja(item.id);
      },
    },
  ];

  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>#</th>
          <th className={thclass}>Paciente</th>
          <th className={thclass}>Fecha</th>
          <th className={thclass}>Estado</th>
          <th className={thclass}>Hora</th>
          <th className={thclass}>Método</th>
          {action && <th className={thclass}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {notifications.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>{index + 1}</td>
            <td className={tdclass}>
              <div className="flex gap-4 items-center">
                <div>
                  <h4 className="text-sm font-medium">
                    {item?.patient?.persona?.nombre +
                      " " +
                      item?.patient?.persona?.apellidos}
                  </h4>
                </div>
              </div>
            </td>
            <td className={tdclass}>
              {new Date(item.fecha).toLocaleDateString("en-gb")}
            </td>
            <td className={tdclass}>
              <span
                className={`py-1 px-4 ${
                  item.estado === "completado"
                    ? "bg-subMain text-subMain"
                    : item.estado === "pendiente"
                    ? "bg-orange-500 text-orange-500"
                    : item.estado === "baja" && "bg-red-600 text-red-600"
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.estado}
              </span>
            </td>
            <td className={`${tdclass} font-semibold`}>
              {new Date(item.fecha).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </td>
            <td className={tdclass}>{`${item.sistema ? "Web" : ""} ${
              item.sistema && item.mail ? "|" : ""
            } ${item.mail ? "Email" : ""}`}</td>
            {item?.tipo === "manual" && (
              <td className={tdclass}>
                <MenuSelect2 datas={DropDown1} item={item}>
                  <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect2>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
// invoice table
export function InvoiceTable({ data }) {
  const navigate = useNavigate();
  const DropDown1 = [
    {
      title: "Editar",
      icon: FiEdit,
      onClick: (item) => {
        navigate(`/invoices/edit/${item.id}`);
      },
    },
    {
      title: "Ver",
      icon: FiEye,
      onClick: (item) => {
        navigate(`/invoices/preview/${item.id}`);
      },
    },
    {
      title: "Baja",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Invoice ID</th>
          <th className={thclass}>Patient</th>
          <th className={thclass}>Created Date</th>
          <th className={thclass}>Due Date</th>
          <th className={thclass}>
            Amout <span className="text-xs font-light">(Tsh)</span>
          </th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>#{item?.id}</td>
            <td className={tdclass}>
              <div className="flex gap-4 items-center">
                <span className="w-12">
                  <img
                    src={item?.to?.image}
                    alt={item?.to?.title}
                    className="w-full h-12 rounded-full object-cover border border-border"
                  />
                </span>
                <div>
                  <h4 className="text-sm font-medium">{item?.to?.title}</h4>
                  <p className="text-xs mt-1 text-textGray">
                    {item?.to?.email}
                  </p>
                </div>
              </div>
            </td>
            <td className={tdclass}>{item?.createdDate}</td>
            <td className={tdclass}>{item?.dueDate}</td>
            <td className={`${tdclass} font-semibold`}>{item?.total}</td>
            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// prescription table
export function MedicineTable({ data, onEdit }) {
  const DropDown1 = [
    {
      title: "Editar",
      icon: FiEdit,
      onClick: (item) => {
        onEdit(item);
      },
    },
    {
      title: "Baja",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Name</th>
          <th className={thclass}>
            Price <span className="text-xs font-light">(Tsh)</span>
          </th>
          <th className={thclass}>Status</th>
          <th className={thclass}>InStock</th>
          <th className={thclass}>Measure</th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <h4 className="text-sm font-medium">{item?.name}</h4>
            </td>
            <td className={`${tdclass} font-semibold`}>{item?.price}</td>
            <td className={tdclass}>
              <span
                className={`text-xs font-medium ${
                  item?.status === "Out of stock"
                    ? "text-red-600"
                    : "text-green-600"
                }`}
              >
                {item?.status}
              </span>
            </td>
            <td className={tdclass}>{item?.stock}</td>
            <td className={tdclass}>{item?.measure}</td>
            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// service table
export function ServiceTable({ data, onEdit }) {
  const DropDown1 = [
    {
      title: "Editar",
      icon: FiEdit,
      onClick: (item) => {
        onEdit(item);
      },
    },
    {
      title: "Baja",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Name</th>
          <th className={thclass}>Created At</th>
          <th className={thclass}>
            Price <span className="text-xs font-light">(Tsh)</span>
          </th>
          <th className={thclass}>Status</th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <h4 className="text-sm font-medium">{item?.name}</h4>
            </td>
            <td className={tdclass}>{item?.date}</td>
            <td className={`${tdclass} font-semibold`}>{item?.price}</td>
            <td className={tdclass}>
              <span
                className={`text-xs font-medium ${
                  !item?.status ? "text-red-600" : "text-green-600"
                }`}
              >
                {!item?.status ? "Disabled" : "Enabled"}
              </span>
            </td>
            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// patient table
export function PatientTable({ data, functions, used }) {
  const dispatch = useDispatch();

  // --- State for pagination ---
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10000);

  // Calculate total pages
  const totalPages = Math.ceil(data.length / recordsPerPage);

  // Get current records to display
  const currentRecords = useMemo(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    return data.slice(indexOfFirstRecord, indexOfLastRecord);
  }, [data, currentPage, recordsPerPage]);

  // Handle page changes
  const goToNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const goToPreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  // Handle records per page change
  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing records per page
  };
  // --- End State for pagination ---

  const DropDown1 = !used
    ? [
        {
          title: "Ver",
          icon: FiEye,
          onClick: (id) => {
            functions.preview(id);
            dispatch(setPatient(id));
          },
        },
        {
          title: "Editar",
          icon: RiEdit2Line,
          onClick: (id) => {
            functions.edit(id);
            dispatch(setPatient(id));
          },
        },
        {
          title: "Baja",
          icon: RiDeleteBin6Line,
          onClick: (id) => {
            functions.delete(id);
          },
        },
      ]
    : [
        {
          title: "View",
          icon: FiEye,
          onClick: (data) => {
            functions.preview(data.id);
          },
        },
      ];

  const thclasse = "text-start text-sm font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";

  return (
    <>
      <table className="table-auto w-full">
        <thead className="bg-dry rounded-md overflow-hiden">
          <tr>
            <th className={thclasse}>#</th>
            <th className={thclasse}>Paciente</th>
            <th className={thclasse}>Celular</th>
            <th className={thclasse}>Sexo</th>
            {!used && (
              <>
                <th className={thclasse}>Fecha Nacimiento</th>
                <th className={thclasse}>Edad</th>
              </>
            )}
            <th className={thclasse}>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((item, index) => (
            <tr
              key={item.id}
              className="border-b border-border hover:bg-greyed transitions"
              // If DropDown1.preview is meant to be a general row click, ensure it's a function.
              // Otherwise, remove or adjust this onClick if it's interfering with the Link.
              // For this example, I'm assuming it's safe or will be handled by the Link.
              // onClick={DropDown1.preview}
            >
              <td className={tdclasse}>
                {/* Adjust index for pagination */}
                {index + 1 + (currentPage - 1) * recordsPerPage}
              </td>
              <td className={tdclasse}>
                <div className="flex gap-4 items-center">
                  <Link
                    to={`/patients/preview/${item.id}`}
                    onClick={() => dispatch(setPatient(item.id))}
                  >
                    <h4 className="text-sm font-medium">{`${item.persona.nombre} ${item.persona.apellidos}`}</h4>
                    <p className="text-xs mt-1 text-textGray">
                      {item.persona.ci.length > 10
                        ? item.persona.ci.slice(0, 8)
                        : item.persona.ci}
                    </p>
                  </Link>
                </div>
              </td>
              <td className={tdclasse}>{item.persona.telf1}</td>
              <td className={tdclasse}>
                <span
                  className={`py-1 px-4 ${
                    item.persona.sexo === "Masculino"
                      ? "bg-subMain text-subMain"
                      : "bg-orange-500 text-orange-500"
                  } bg-opacity-10 text-xs rounded-xl`}
                >
                  {item.persona.sexo}
                </span>
              </td>
              {!used && (
                <>
                  <td className={tdclasse}>
                    {item.persona.fecha_nacimiento
                      ? formatDateWithoutTimeZoneIssues(
                          item.persona.fecha_nacimiento
                        )
                      : item.persona.fecha_nacimiento}
                  </td>
                  <td className={tdclasse}>
                    {getAge(new Date(item.persona.fecha_nacimiento))}
                  </td>
                </>
              )}
              <td className={tdclasse}>
                <MenuSelect datas={DropDown1} item={item}>
                  <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* --- Pagination Controls --- */}
      <div className="flex justify-between items-center mt-4 p-2"></div>
    </>
  );
}
// doctor table
export function DoctorsTable({ data, functions, doctor }) {
  const DropDown1 = [
    {
      title: "Ver",
      icon: FiEye,
      onClick: (data) => {
        functions.preview(data);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>#</th>
          <th className={thclass}>{doctor ? "Doctor" : "Receptionist"}</th>
          <th className={thclass}>Created At</th>
          <th className={thclass}>Phone</th>
          <th className={thclass}>Title</th>
          <th className={thclass}>Email</th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>{index + 1}</td>
            <td className={tdclass}>
              <div className="flex gap-4 items-center">
                <span className="w-12">
                  <img
                    src={item.user.image}
                    alt={item.user.title}
                    className="w-full h-12 rounded-full object-cover border border-border"
                  />
                </span>
                <h4 className="text-sm font-medium">{item.user.title}</h4>
              </div>
            </td>
            <td className={tdclass}>12 May, 2021</td>
            <td className={tdclass}>
              <p className="text-textGray">{item.user.phone}</p>
            </td>
            <td className={tdclass}>{item.title}</td>
            <td className={tdclass}>{item.user.email}</td>

            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// appointment table
export function AppointmentTable({ data, functions, doctor, view = false }) {
  const DropDown1 = [
    {
      title: "Ver",
      icon: FiEye,
      onClick: (id) => {
        functions.preview(id);
      },
    },
    {
      title: "Atención",
      icon: MdMedicalServices,
      onClick: (id) => {
        functions.attention(id);
      },
    },
    {
      title: "Editar",
      icon: RiEdit2Line,
      onClick: (id) => {
        functions.edit(id);
      },
    },
    {
      title: "Baja",
      icon: RiDeleteBin6Line,
      onClick: (id) => {
        toast.error(`This feature is not available yet =>>>> id: ${id}`);
      },
    },
  ];

  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Fecha</th>
          <th className={thclass}>Estado</th>
          <th className={thclass}>Hora</th>
          {!view && <th className={`${thclass} mr-5`}>Opciones</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <p className="text-xs">
                {new Date(item?.fecha).toLocaleDateString("en-GB")}
              </p>
            </td>

            <td className={tdclass}>
              <span
                className={`py-1  px-4 ${
                  item.estado === "en curso"
                    ? "bg-subMain text-subMain"
                    : item.estado === "cerrada"
                    ? "bg-orange-500 text-orange-500"
                    : item.estado === "vencida" && "bg-red-600 text-red-600"
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.estado}
              </span>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{`${new Date(
                item.hora_inicio
              ).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })} - ${new Date(item.hora_fin).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}`}</p>
            </td>
            {!view && (
              <td className={`${tdclass} mr-5`}>
                <MenuSelect datas={DropDown1} item={item}>
                  <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// payment table
export function PaymentTable({ data, functions, doctor }) {
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Date</th>
          <th className={thclass}>{doctor ? "Patient" : "Doctor"}</th>
          <th className={thclass}>Status</th>
          <th className={thclass}>Amount</th>
          <th className={thclass}>Method</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <p className="text-xs">{item.date}</p>
            </td>
            <td className={tdclass}>
              <h4 className="text-xs font-medium">
                {doctor ? item.user.title : item.doctor.title}
              </h4>
              <p className="text-xs mt-1 text-textGray">
                {doctor ? item.user.phone : item.doctor.phone}
              </p>
            </td>
            <td className={tdclass}>
              <span
                className={`py-1  px-4 ${
                  item.status === "Paid"
                    ? "bg-subMain text-subMain"
                    : item.status === "Pending"
                    ? "bg-orange-500 text-orange-500"
                    : item.status === "Cancel" && "bg-red-600 text-red-600"
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.status}
              </span>
            </td>
            <td className={tdclass}>
              <p className="text-xs font-semibold">{`$${item.amount}`}</p>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{item.method}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item.id)}
                className="text-sm flex-colo bg-white text-subMain border rounded-md w-10 h-10"
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice used table
export function InvoiceUsedTable({ data, functions }) {
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Invoice ID</th>
          <th className={thclass}>Create Date</th>
          <th className={thclass}>Due Date</th>
          <th className={thclass}>Amount</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <p className="text-xs">#{item.id}</p>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{item.createdDate}</p>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{item.dueDate}</p>
            </td>

            <td className={tdclass}>
              <p className="text-xs font-semibold">{`$${item.total}`}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item.id)}
                className="text-sm flex-colo bg-white text-subMain border rounded-md w-10 h-10"
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice table
export function InvoiceProductsTable({ data, functions, button }) {
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Item</th>
          <th className={thclass}>
            Item Price
            <span className="text-xs font-light ml-1">(Tsh)</span>
          </th>
          <th className={thclass}>Quantity</th>
          <th className={thclass}>
            Amout
            <span className="text-xs font-light ml-1">(Tsh)</span>
          </th>
          {button && <th className={thclass}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={`${tdclass}  font-medium`}>{item.name}</td>
            <td className={`${tdclass} text-xs`}>{item.price}</td>
            <td className={tdclass}>{item.id}</td>
            <td className={tdclass}>{item.price * item.id}</td>
            {button && (
              <td className={tdclass}>
                <button
                  onClick={() => functions.deleteItem(item.id)}
                  className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// medicine Dosage table

export function MedicineDosageTable({ data, functions, button }) {
  const thclasse = "text-start text-xs font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";

  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclasse}>Item</th>
          <th className={thclasse}>Instrucciones</th>
          <th className={thclasse}>Cantidad</th>
          <th className={thclasse}>Presentación</th>

          {button && !data?.at(0)?.id && (
            <th className={thclasse}>Operación</th>
          )}
        </tr>
      </thead>
      <tbody>
        {data?.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclasse}>{item?.nombre}</td>
            <td className={tdclasse}>{item?.instrucciones}</td>
            <td className={tdclasse}>{item?.cantidad}</td>
            <td className={tdclasse}>{item?.presentacion}</td>

            {button && !data?.at(0)?.id && (
              <td className={tdclasse}>
                <button
                  onClick={() => functions.delete(index)}
                  className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/* export function LaboratoryTable({
  data,
  functions,
  button,
  view,
  cita,
  viewString,
}) {
  const thclasse = "text-start text-xs font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const todosEstudios = data;
  const patient = cita?.patient;
  const isDesktop = useViewType();

  // Usar todos los estudios o filtrar por cita según sea necesario
  const estudiosMostrar =
    viewString === "360"
      ? todosEstudios
      : cita
      ? todosEstudios?.filter((estudio) => estudio.cita_id === cita?.id)
      : todosEstudios;

  const renderModalContent = () => {
    switch (selected?.tipo) {
      case "Laboratorio":
        return (
          <Laboratorio
            data={{ ...selected, patient_id: patient?.id }}
            onClose={() => setOpen(false)}
          />
        );
      case "Gabinete Cardiologico":
        return (
          <Ecocardiograma
            data={{ ...selected, patient_id: patient?.id }}
            nuevo={selected.id}
            onClose={() => setOpen(false)}
          />
        );
      case "Analisis de Gabinete":
        return (
          <AnalisisGabinete
            data={{ ...selected, patient_id: patient?.id }}
            onClose={() => setOpen(false)}
          />
        );
      default:
        return <h1>No encontrado</h1>;
    }
  };

  return (
    <>
      {open && (
        <Modal
          title={`Valores de ${selected?.tipo}`}
          isOpen={open}
          closeModal={() => {
            setOpen(false);
          }}
          width={viewString === "360" ? "max-w-xl" : "max-w-4xl"}
        >
          {renderModalContent()}
        </Modal>
      )}
      <div className="overflow-x-auto">
        <table className="table-auto w-full">
          <thead className="bg-dry rounded-md">
            <tr>
              {isDesktop && <th className={thclasse}>#</th>}
              {patient && <th className={thclasse}>Paciente</th>}
              <th className={thclasse}>Tipo</th>
              <th className={thclasse}>Nombre</th>
              {!view ? (
                <th className={thclasse}>Pdf</th>
              ) : (
                <th className={thclasse}>Fecha</th>
              )}
              <th className={thclasse}>Adjunto</th>
              {!view && <th className={thclasse}>Archivo</th>}
              {!view && <th className={thclasse}>Operación</th>}
            </tr>
          </thead>
          <tbody>
            {estudiosMostrar?.map((item, index) => (
              <tr
                key={`${index}_${item.tipo}`}
                className="border-b border-border hover:bg-gray-100 cursor-pointer transition-colors duration-200"
              >
                {isDesktop && <td className={tdclasse}>{index + 1}</td>}
                {patient && (
                  <td className={tdclasse}>
                    {patient?.persona?.nombre +
                      " " +
                      patient?.persona?.apellidos}
                  </td>
                )}
                <td
                  className={tdclasse}
                  onClick={() => {
                    if (
                      !view &&
                      viewString !== "360" &&
                      item?.modulo_ubicacion !== "Antecedentes"
                    ) {
                      setOpen(true);
                      setSelected(item);
                    }
                  }}
                >
                  {item?.tipo ?? ""}
                </td>
                <td
                  className={tdclasse + " cursor-pointer"}
                  onClick={() => {
                    if (
                      !view &&
                      viewString !== "360" &&
                      item?.modulo_ubicacion !== "Antecedentes"
                    ) {
                      setOpen(true);
                      setSelected(item);
                    }
                  }}
                >
                  {item?.nombre ?? item?.tipo}
                </td>
                {view && (
                  <td className={tdclasse}>
                    {new Date(item?.created_at).toLocaleDateString("en-GB")}
                  </td>
                )}
                {!view && (
                  <td>
                    {item?.nombre !== "Adjuntos" && item?.modulo_ubicacion && (
                      <button
                        onClick={() => functions.printPdf(item)}
                        className="flex justify-center items-center bg-subMain rounded-full text-white text-center text-2xl p-2"
                      >
                        <FaFileDownload />
                      </button>
                    )}
                  </td>
                )}
                <td className={tdclasse + " cursor-pointer"}>
                  {item?.archivo?.split("/")?.at(-1).substr(0, 20) ?? ""}
                </td>
                {!view && (
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.archivo && (
                      <a
                        href={item?.archivo}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-subMain"
                      >
                        <span className="mr-2 inline-block">
                          <FileIcon
                            extension={item?.archivo
                              ?.split("/")
                              ?.at(-1)
                              .split(".")
                              .pop()}
                          />
                        </span>
                        Descargar
                      </a>
                    )}
                  </td>
                )}
                {!view && (
                  <td className={tdclasse}>
                    {button &&
                      item?.id &&
                      item?.modulo_ubicacion !== "Antecedentes" && (
                        <button
                          onClick={() => functions.delete(item)}
                          className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                        >
                          <RiDeleteBinLine />
                        </button>
                      )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
} */
export function LaboratoryTable({
  data,
  functions,
  button,
  view,
  cita,
  viewString,
}) {
  const thclasse = "text-start text-xs font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  // Filtrar y procesar los estudios
  const procesarEstudios = (estudios) => {
    const grupos = {};

    estudios?.forEach((estudio) => {
      if (estudio.cita_id === cita?.id) {
        // Para laboratorios, agrupar por orden_lab
        if (estudio.tipo === "Laboratorio") {
          const key = `lab-${estudio.orden_lab}`;
          if (!grupos[key]) {
            grupos[key] = {
              ...estudio,
              esGrupo: true,
              cantidad: 1,
              nombres: [estudio.nombre || "Laboratorio"],
            };
          } else {
            grupos[key].cantidad += 1;
            grupos[key].nombres.push(estudio.nombre || "Laboratorio");
          }
        }
        // Para gabinetes, mostrar individualmente
        else if (estudio.tipo === "Analisis de Gabinete") {
          const key = `gabinete-${estudio.id}`;
          grupos[key] = {
            ...estudio,
            esGrupo: false,
            cantidad: 1,
            nombres: [estudio.nombre || "Análisis de Gabinete"],
          };
        }
      }
    });

    return Object.values(grupos);
  };

  const estudiosMostrar = procesarEstudios(data);
  const patient = cita?.patient;

  const renderModalContent = () => {
    switch (selected?.tipo) {
      case "Laboratorio":
        return (
          <Laboratorio
            data={{ ...selected, patient_id: patient.id }}
            onClose={() => setOpen(false)}
          />
        );
      case "Analisis de Gabinete":
        return (
          <AnalisisGabinete
            data={{ ...selected, patient_id: patient?.id }}
            onClose={() => setOpen(false)}
          />
        );
      default:
        return <h1>No encontrado</h1>;
    }
  };

  return (
    <>
      {open && (
        <Modal
          title={`Valores de ${selected?.tipo}`}
          isOpen={open}
          closeModal={() => {
            setOpen(false);
          }}
          width={"max-w-4xl"}
        >
          {renderModalContent()}
        </Modal>
      )}
      <table className="table-auto w-full">
        <thead className="bg-dry rounded-md overflow-hidden">
          <tr>
            <th className={thclasse}>#</th>
            {patient && <th className={thclasse}>Paciente</th>}
            <th className={thclasse}>Tipo</th>
            <th className={thclasse}>Nombre</th>
            {/* <th className={thclasse}>Cantidad</th> */}
            {(view || patient) && <th className={thclasse}>Fecha</th>}
            {<th className={thclasse}>Operación</th>}
            {!view && <th className={thclasse}>Pdf</th>}
          </tr>
        </thead>
        <tbody>
          {estudiosMostrar?.map((item, index) => (
            <tr
              key={`${item.tipo}-${item.esGrupo ? item.orden_lab : item.id}`}
              className="border-b border-border hover:bg-greyed transitions"
            >
              <td className={tdclasse}>{index + 1}</td>
              {patient && (
                <th className={thclasse}>
                  {patient?.persona?.nombre + " " + patient?.persona?.apellidos}
                </th>
              )}
              <td className={tdclasse}>{item.tipo}</td>
              <td
                className={tdclasse + " cursor-pointer"}
                onClick={() => {
                  if (!view) {
                    setOpen(true);
                    setSelected(item);
                  }
                }}
              >
                {item.esGrupo ? `Laboratorio` : item.nombres[0]}
              </td>
              {/* <td className={tdclasse}>{item.cantidad}</td> */}
              {(view || patient) && (
                <td className={tdclasse}>
                  {new Date().toLocaleDateString("en-GB")}
                </td>
              )}
              {item.modulo_ubicacion && (
                <td className={tdclasse}>
                  <button
                    onClick={() => functions.delete(item)}
                    className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                  >
                    <RiDeleteBinLine />
                  </button>
                </td>
              )}
              {item.modulo_ubicacion && (
                <td>
                  <button
                    onClick={() => functions.printPdf(item)}
                    className="flex justify-center items-center bg-subMain rounded-full text-white text-center text-2xl p-2"
                  >
                    <FaFileDownload />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export function LaboratoriesTable({
  data,
  functions,
  button,
  id,
  view = false,
}) {
  const thclasse = "text-start text-xs font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [selected, setSelected] = useState(1);
  const datos = [
    {
      id: 1,
      nombre: "Laboratorio",
      tipo: "Laboratorio",
    },
    {
      id: 2,
      nombre: "Ecocardiograma",
      tipo: "Ecocardiograma",
    },
    {
      id: 3,
      nombre: "Electrocardiograma",
      tipo: "Electrocardiograma",
    },
    {
      id: 4,
      nombre: "Analisis de Gabinete",
      tipo: "Endoscopia",
    },
  ];
  return (
    <table className="table-auto w-full">
      {open && (
        <Modal
          title="Valores de Análisis"
          isOpen={open}
          closeModal={() => {
            setOpen(false);
          }}
          width={"max-w-lg"}
        >
          <Ecocardiograma />
        </Modal>
      )}
      {open2 && selected === 4 && (
        <Modal
          title="Valores de Análisis Gabinete"
          isOpen={open2}
          closeModal={() => {
            setOpen2(false);
          }}
          width={"max-w-lg"}
        >
          <AnalisisGabinete />
        </Modal>
      )}
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclasse}>#</th>
          {!id && <th className={thclasse}>Paciente</th>}
          <th className={thclasse}>Tipo</th>
          <th className={thclasse}>Nombre</th>
          <th className={thclasse}>Fecha</th>
          {button && !view && <th className={thclasse}>Operación</th>}
          {!view && <th className={thclasse}>Pdf</th>}
        </tr>
      </thead>
      <tbody>
        {datos?.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclasse}>{index + 1}</td>
            {!id && (
              <td
                className={thclasse}
                onClick={() => {
                  setSelected(item.id);
                  if (item.id === 4) setOpen2(true);
                  else setOpen(!open);
                }}
              >
                Nombre Paciente
              </td>
            )}
            <td
              className={tdclasse}
              onClick={() => {
                setSelected(item.id);
                if (item.id === 4) setOpen2(true);
                else setOpen(!open);
              }}
            >
              {item.nombre}
            </td>
            <td
              className={tdclasse}
              onClick={() => {
                setSelected(item.id);
                if (item.id === 4) setOpen2(true);
                else setOpen(!open);
              }}
            >
              {item?.tipo}
            </td>
            <td
              className={tdclasse}
              onClick={() => {
                setSelected(item.id);
                if (item.id === 4) setOpen2(true);
                else setOpen(!open);
              }}
            >
              {"21/10/2023"}
            </td>
            {button && !view && (
              <td className={tdclasse}>
                <button
                  onClick={() => functions.delete(item.id)}
                  className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
            {!view && (
              <td>
                <button className="flex justify-center items-center bg-subMain rounded-full text-white text-center text-2xl p-2">
                  <FaFileDownload />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function FilesTable({ data, functions }) {
  return (
    <div className="relative overflow-hidden rounded-lg border border-border">
      <div className="max-h-[60vh] overflow-y-auto">
        <table className="table-auto w-full">
          <thead className="bg-dry sticky top-0 z-10">
            <tr>
              <th className={thclass}>Fecha</th>
              <th className={thclass}>Tipo de Certificado</th>
              <th className={thclass}>Pdf</th>
              <th className={thclass}>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item) => (
              <tr key={item.id}>
                <td className={tdclass}>{item.fecha}</td>
                <td className={tdclass}>
                  {item.template?.nombre || "Sin plantilla"}
                </td>
                <td className={tdclass}>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() =>
                        functions.print(
                          item.contenido,
                          item.template?.nombre || "Sin plantilla",
                          item.template?.id || 0
                        )
                      }
                      className="w-10 h-10 flex justify-center items-center bg-subMain rounded-full text-white text-center text-2xl p-2"
                    >
                      <FaFileDownload />
                    </button>
                  </div>
                </td>
                <td className={tdclass}>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => functions.delete(item.id)}
                      className="w-10 h-10 bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-1 px-2 text-2xl"
                    >
                      <RiDeleteBinLine />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export const VaccineOrderTable = ({ data, functions, button }) => {
  // Función segura para formatear fechas sin problemas de zona horaria
  /*  const formatDateWithoutTimeZoneIssues = (isoString) => {
    // Dividir la fecha y hora para ignorar la zona horaria
    const [datePart] = isoString.split("T");
    const [year, month, day] = datePart.split("-");

    // Crear fecha local sin considerar la hora/UTC
    return new Date(year, month - 1, day).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }; */

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Vacuna
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Dosis
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Fecha Aplicación
            </th>
            {button && (
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data?.length > 0 ? (
            data?.map((item, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{item.vacuna}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{item.tipo_dosis}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">
                    {
                      /* {new Date(item.fecha_aplicacion).toLocaleDateString(
                      "en-GB"
                    )} */ /* formatDateWithoutTimeZoneIssues( */ formatDateWithoutTimeZoneIssues(
                        item.fecha_aplicacion
                      )
                    }
                  </div>
                </td>
                {button && (
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex gap-4">
                      {/*  <button
                        onClick={() => functions.printPdf(item)}
                        className="text-subMain"
                      >
                        <FaFileDownload />
                      </button> */}
                      {/* <button
                        onClick={() => functions?.delete(item)}
                        className="text-red-500"
                      >
                        <FaTimes />
                      </button>
 */}
                      <button
                        onClick={() => functions?.delete(item)}
                        className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                      >
                        <RiDeleteBinLine />
                      </button>
                    </div>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={button ? 6 : 5}
                className="px-6 py-4 text-center text-sm text-gray-500"
              >
                No hay vacunas registradas
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
